const getData = (client, queryObject, identifier) => {
  return new Promise((resolve, reject) => {
    client
      .query(queryObject)
      .then(({ data }) => {
        resolve(data[identifier] || new Array());
      })
      .catch((err) => {
        console.log(`Catch: getData: error: ${err}`);
        // reject("Something Went Wrong while getting Data!");
        reject(err);
      });
  });
};

const getDataWithoutRejection = (client, queryObject, identifier) => {
  return new Promise((resolve, reject) => {
    client
      .query(queryObject)
      .then(({ data }) => {
        resolve(data[identifier] || new Array());
      })
      .catch((err) => {
        console.log(`Catch: getData: error: ${err}`);
        resolve([]);
      });
  });
};

const getDataWithRef = (client, queryObject, identifier) => {
  return new Promise((resolve, reject) => {
    client
      .query(queryObject)
      .then(({ data }) => {
        resolve({
          api: identifier,
          data: data[identifier] || new Array(),
        });
      })
      .catch((err) => {
        console.log(`Catch: getData: error: ${err}`);
        // reject("Something Went Wrong while getting Data!");
        reject(err);
      });
  });
};

const updateData = (client, mutationObject, identifier) => {
  return new Promise((resolve, reject) => {
    client
      .mutate(mutationObject)
      .then(({ data }) => {
        resolve(data[identifier]);
      })
      .catch((err) => {
        // console.log("err :::", err);
        reject(err);
      });
  });
};

const batchUpdates = (client, api, identifier, data, size) => {
  return new Promise(async (resolve, reject) => {
    try {
      for (let i = 0; i < data.length; i += size) {
        // console.log("data.slice(i, i + size) :::", data.slice(i, i + size))
        await updateData(
          client,
          {
            mutation: api,
            variables: {
              input: data.slice(i, i + size),
            },
          },
          identifier
        );
      }
      resolve(true);
    } catch (err) {
      reject(err);
    }
  });
};

const getDataInLoop = (client, limits, additionalActions) => {
  return new Promise(async (resolve, reject) => {
    try {
      let finalData = [],
        skips = 0,
        data = [],
        { api, variables = {}, dataField, fetchPolicy } = additionalActions;
      do {
        data = await getData(
          client,
          {
            query: api,
            variables: {
              skips,
              limits,
              ...variables,
            },
            fetchPolicy,
          },
          dataField
        );
        finalData = [...finalData, ...data];
        skips += limits;
      } while (data.length === limits);
      resolve(finalData);
    } catch (err) {
      reject(err);
    }
  });
};

const getDataInLoopWithSource = (client, limits, additionalActions, source) => {
  return new Promise(async (resolve, reject) => {
    try {
      let finalData = [],
        skips = 0,
        data = [],
        { api, variables = {}, dataField, fetchPolicy } = additionalActions;
      do {
        data = await getData(
          client,
          {
            query: api,
            variables: {
              skips,
              limits,
              ...variables,
            },
            fetchPolicy,
          },
          dataField
        );
        finalData = [...finalData, ...data];
        skips += limits;
      } while (data.length === limits);

      resolve({ data: finalData, source: source });
      resolve(finalData);
    } catch (err) {
      reject(err);
    }
  });
};

export { getData, updateData, getDataInLoop, batchUpdates, getDataInLoopWithSource, getDataWithRef, getDataWithoutRejection };
